enum PopoverAnchorSelectors {
    findAuctionsTrigger = '[data-testid="findAuctionsTrigger"]',
    headerMenuButton = '[data-testid="headerMenuButton"]',
    howToWinNavLink = '[data-testid="howToWinNavLink"]',
}

export enum ViewportType {
    Mobile = 'mobile',
    NarrowDesktop = 'narrowDesktop',
    WideDesktop = 'wideDesktop',
}

export type ResolvedAnchor = {
    element: Element;
    selector: string;
};

/**
 * Resolves the anchor element for the HowToWin popover.
 *
 * Determines which DOM element the popover should attach to and find it.
 * The anchor varies by viewport—mobile uses the menu button, narrow desktop uses find auctions,
 * wide desktop uses the how-to-win nav link.
 *
 * Called only when the banner is dismissed (lazy resolution).
 *
 * @param viewport - Mobile (≤954px), NarrowDesktop (954–1400px), WideDesktop (≥1400px)
 * @returns Resolved anchor with selector and element, or null if not found
 */
export const resolvePopoverAnchor = (viewport: ViewportType): ResolvedAnchor | null => {
    if (viewport === ViewportType.Mobile) {
        const element = document.querySelector(PopoverAnchorSelectors.headerMenuButton);
        return element ? { element, selector: PopoverAnchorSelectors.headerMenuButton } : null;
    }

    if (viewport === ViewportType.WideDesktop) {
        const element = document.querySelector(PopoverAnchorSelectors.howToWinNavLink);
        return element ? { element, selector: PopoverAnchorSelectors.howToWinNavLink } : null;
    }

    const element = document.querySelector(PopoverAnchorSelectors.findAuctionsTrigger);
    return element ? { element, selector: PopoverAnchorSelectors.findAuctionsTrigger } : null;
};
